import { ExternalLink } from "lucide-react";
import { useT } from "@/lib/i18n";
import { fmtDate } from "@/lib/utils";

const COLS = ["Pos", "Team", "Pld", "W", "D", "L", "GF", "GA", "GD", "Pts"];
const KEY = { Pos: "pos", Team: "team", Pld: "pld", W: "w", D: "d", L: "l", GF: "gf", GA: "ga", GD: "gd", Pts: "pts" };

export const StandingsTable = ({ s }) => {
  const { t } = useT();
  return (
    <div className="overflow-hidden rounded-xl border border-slate-100 bg-white shadow-sm" data-testid={`standings-${s.slug}`}>
      <div className="flex flex-wrap items-center justify-between gap-2 border-b border-slate-100 bg-[#0B1120] px-4 py-3 text-white">
        <h3 className="font-display text-xl font-extrabold">{s.name}{s.group ? ` · ${s.group}` : ""}</h3>
        <span className="text-xs text-slate-300">{t("Season")} {s.season}</span>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 text-xs uppercase tracking-wider text-slate-500"><tr>{COLS.map((c) => <th key={c} className={`px-3 py-2 ${c === "Team" ? "text-left" : "text-center"}`}>{t(c)}</th>)}</tr></thead>
          <tbody>
            {s.rows.map((r, i) => {
              const cm = /cameroon|cameroun/i.test(r.team);
              return (
                <tr key={i} data-testid={`standings-row-${i}`} className={`border-t border-slate-100 ${cm ? "bg-emerald-50 font-bold" : ""}`}>
                  {COLS.map((c) => <td key={c} className={`px-3 py-2 ${c === "Team" ? "text-left font-semibold text-slate-900" : "text-center text-slate-700"} ${c === "Pts" ? "font-display text-base font-black" : ""}`}>{c === "Pos" && r.note ? <span title={r.note} className="rounded bg-[#047857] px-1.5 py-0.5 text-[11px] text-white">{r.pos}</span> : r[KEY[c]] ?? "—"}</td>)}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <p className="flex items-center gap-1 px-4 py-2 text-[11px] text-slate-400">{t("Source:")} {s.source} <a href={s.source_url} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1 text-[#047857] hover:underline">{s.source_url?.replace("https://", "").slice(0, 40)}… <ExternalLink size={10} /></a> · {fmtDate(s.updated_at, false)}</p>
    </div>
  );
};
